export const version = "5.17.1";
export const major = Number("5");
export const minor = Number("17");
export const patch = Number("1");
export const preReleaseLabel = undefined || null;
export const preReleaseNumber = Number(undefined) || null;
export default version;